export enum TargetMetricsEnum {
  Posts = 1,
  RollingTime = 2,
  DateTime = 3

}

export enum RepeatOnDaysEnum {
  "Monday" = 1,
  "Tuesday" = 2,
  "Wednesday" = 3,
  "Thursday" = 4,
  "Friday" = 5,
  "Saturday" = 6,
  "Sunday" = 7
}


export enum DisplayBy {
  Users = 1,
  UserGroups = 2

}

export enum DisplayByAvg {
  Total = 0,
  Average = 1

}


export enum ScoreBasedOn {
  Shares = 1,
  Clicks = 2,
  EMV = 3
}

export enum ScoredBasedOn {
  "clicked_count" = "Clicks",
  "emv" = "EMV",
  "average" = "EMV",
  "shared_count" = "Shares",
  "share" = "Shares",
  "click" = "Clicks",
}

export enum RepeatOnDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7
}

export enum TARGET_METRIC {
  POSTS = 1,
  ROLLING_TIME = 2,
  DATE_RANGE = 3
}


